import { styleOverrides } from "./styleOverrides";

const MuiTooltip = {
  styleOverrides,
};

export { MuiTooltip };
